import { render, staticRenderFns } from "./DashboardGrid.vue?vue&type=template&id=74f47abc&"
import script from "./DashboardGrid.vue?vue&type=script&lang=js&"
export * from "./DashboardGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports